module.exports = "https://static.energy5.com/_next/static/images/screen-d012643f7a4d3b7511fcba3797997fb1.png";